import { Button, Link } from '@/components/Elements';
import { InputField, PasswordField } from '@/components/Form';
import { useLogin } from '@/lib/auth';
import { PRIVATE_TOP_PATH } from '@/routes/private';
import { createUrlWithRedirectQuery, getSafeRedirectPath } from '@/utils/url';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';

export const LoginForm = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const login = useLogin();
  const [searchParams] = useSearchParams();
  const redirectPath = getSafeRedirectPath(searchParams.get('to'));
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const canSubmit = email && password;

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    // 重複送信防止: 条件チェックと送信中状態の確認
    if (!canSubmit || login.isPending) return;

    login.mutate(
      {
        email,
        password,
      },
      {
        onSuccess: () => {
          if (redirectPath) {
            window.location.href = redirectPath;
            return;
          }

          navigate(PRIVATE_TOP_PATH);
        },
      }
    );
  };

  return (
    <form className="space-y-6" onSubmit={onSubmit}>
      <InputField
        label={t('メールアドレス')}
        type="email"
        value={email}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          setEmail(e.currentTarget.value)
        }
        autoComplete="email"
        placeholder={t('メールアドレスを入力...')}
        error={login.isError}
        required
      />

      <div>
        <PasswordField
          label={t('パスワード')}
          value={password}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setPassword(e.currentTarget.value)
          }
          autoComplete="current-password"
          placeholder={t('パスワードを入力...')}
          error={login.isError}
          errors={[t('メールアドレスまたはパスワードが正しくありません。')]}
          required
        />

        <div className="mt-2 text-right text-sm">
          <Link to="/password-reset">{t('パスワードをお忘れですか？')}</Link>
        </div>
      </div>

      <div>
        <Button
          type="submit"
          size="sm"
          className="w-full"
          isLoading={login.isPending}
          disabled={!canSubmit || login.isPending}
        >
          {t('ログイン')}
        </Button>

        <div className="mt-2 text-sm text-gray-600">
          <span>{t('アカウントをお持ちでないですか？')}</span>
          <Link
            className="ml-1"
            to={createUrlWithRedirectQuery('/auth/register', redirectPath)}
          >
            {t('新規登録')}
          </Link>
        </div>
      </div>
    </form>
  );
};
